module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-913e63dd.svg";